import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "kpi-circle-wrapper" }
const _hoisted_2 = { class: "kpi-labels" }
const _hoisted_3 = { class: "kpi-name" }
const _hoisted_4 = { class: "kpi-percent" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("% ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.label), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_ctx.percent), 1 /* TEXT */),
        _hoisted_5
      ])
    ]),
    _createVNode(_component_apexchart, {
      type: "radialBar",
      options: _ctx.chartOptions,
      series: _ctx.series
    }, null, 8 /* PROPS */, ["options", "series"])
  ]))
}